module.exports = __webpack_public_path__ + "static/fonts/Montserrat-Black.27e3649.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Montserrat-Black.ttf
// module id = 1YRD
// module chunks = 0